exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".food-list[data-v-838efcd4]{padding-left:0}.food-list .food-item[data-v-838efcd4]{margin-top:5px;display:flex;justify-content:space-between;line-height:17px}.food-list .food-item .single-price[data-v-838efcd4]{font-size:12px}.food-list .food-item .name[data-v-838efcd4]{font-weight:bold}.food-list .food-item .price[data-v-838efcd4]{font-weight:bold}\n", ""]);

// exports
